/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hataufenthaltserlaubnis1Inputs */



/**

* @param {_Field_Hataufenthaltserlaubnis1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_hataufenthaltserlaubnis1 = /** @type {((inputs?: _Field_Hataufenthaltserlaubnis1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hataufenthaltserlaubnis1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Benötigt Aufenthaltserlaubnis")
});
export { _field_hataufenthaltserlaubnis1 as "_field_hatAufenthaltserlaubnis" }